import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home'
import MHome from '../views/mhome'
import Yh from '../views/yh.vue'
import Ys from '../views/ys.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/index', name: 'home', component: Home
  }, {
    path: '/mIndex', name: 'mhome', component: MHome
  }, {
    path: '/yhxy', name: 'yhxy', component: Yh
  }, {
    path: '/ysxy', name: 'ysxy', component: Ys
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js